import { render, staticRenderFns } from "./DeleteDesgination.vue?vue&type=template&id=683c3c37"
import script from "./DeleteDesgination.vue?vue&type=script&lang=js"
export * from "./DeleteDesgination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports